import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import BrandLogo from "../components/BrandLogo";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    if (user) return <Navigate to={["admin", "finance", "coach"].includes(user.role) ? "/admin" : "/portal"} replace />;

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const data = await login(email, password);
            navigate(["admin", "finance", "coach"].includes(data.role) ? "/admin" : "/portal");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-white text-neutral-900 flex items-center justify-center px-6" data-testid="admin-login-page">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="w-full max-w-sm"
            >
                <div className="flex items-center gap-3 mb-10">
                    <BrandLogo className="w-10 h-10" testid="admin-login-logo" />
                    <div>
                        <p className="font-display uppercase tracking-wide leading-none">Mandalika Inlineskate</p>
                        <p className="text-[10px] uppercase tracking-[0.25em] text-racing-muted mt-1">Panel Admin</p>
                    </div>
                </div>

                <p className="mb-8 -mt-6 text-xs text-racing-muted border border-racing-line bg-racing-surface px-4 py-3" data-testid="admin-login-hint">
                    Halaman masuk untuk <span className="font-medium text-neutral-900">Admin</span>, <span className="font-medium text-neutral-900">Pelatih</span>, dan <span className="font-medium text-neutral-900">Admin Keuangan</span>. Orang tua atlet masuk melalui menu Portal Orang Tua di halaman utama.
                </p>

                <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
                    <div>
                        <label className="block text-[10px] uppercase tracking-[0.25em] text-racing-muted mb-2">Username / Email</label>
                        <input
                            type="text"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="admin-email-input"
                            className="w-full bg-racing-surface border border-racing-line px-4 py-3.5 text-sm text-neutral-900 focus:outline-none focus:border-racing-red transition-colors duration-300"
                            placeholder="admin@mandalikainlineskate.id"
                        />
                    </div>
                    <div>
                        <label className="block text-[10px] uppercase tracking-[0.25em] text-racing-muted mb-2">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="admin-password-input"
                            className="w-full bg-racing-surface border border-racing-line px-4 py-3.5 text-sm text-neutral-900 focus:outline-none focus:border-racing-red transition-colors duration-300"
                            placeholder="••••••••"
                        />
                    </div>

                    {error && (
                        <p className="text-sm text-racing-red" data-testid="admin-login-error">{error}</p>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-submit"
                        className="w-full bg-racing-red hover:bg-racing-redhover disabled:opacity-50 text-white text-xs uppercase tracking-[0.25em] py-4 transition-colors duration-300"
                    >
                        {loading ? "Memproses..." : "Masuk"}
                    </button>
                </form>
            </motion.div>
        </div>
    );
}
